export default "__VITE_ASSET__BKmrUJYa__"